import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Spin, Table, Input, Button, Popconfirm, message } from 'antd';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { NetworkDelaySearch, schema_to_field, showErrorInNotification, formatMoney } from '../../lib/util';
import { FilterList } from '@material-ui/icons';
import { PopUpForm } from '../../lib/ui/popupform';
import { COLORS } from '../theme';

const queryString = require('query-string');

class CachedDataDetail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            filter_query: {
                per_page: 100,
                page: 1,
            },
            cache_datasource_obj: {},
            loading: true,
            filter_form_visibility:false,
            filter_schema:[]
        }

        this.cache_id = props.match.params.id;

        this.detail_cachedatasource = RESTExecutor.detail().config({
            label: 'detail'
        }).callbacks((success) => {
            this.setState({ loading: false, cache_datasource_obj: success.result ,
                filter_schema:schema_to_field(success.result.filter_config)
            })
           
            this.list_data.forId(this.cache_id).config({
                params: {
                    ...this.state.filter_query
                }
            }).execute()

        }, (error) => {
            this.setState({ loading: false })
        }).forId(this.cache_id).connect(props.domains.cache);

        this.list_data = RESTExecutor.list().config({
            label: 'list_data'
        }).connect(props.domains.cache);

        this.delete_data=RESTExecutor.delete().config({
            label:'cache_data_detail',
            params:{}
        }).callbacks((success)=>{
            message.success("Cache Deleted");
            this.list_data.execute()
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.cache);


        this.delay_search = new NetworkDelaySearch();


    }

    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {

        let detail_cachedatasource_resp = this.detail_cachedatasource.response();
        let list_data_resp = this.list_data.response();
        let delete_data_resp=this.delete_data.response();
        let rowsData = (list_data_resp.result && list_data_resp.result.rows) || [];
        let rowsMeta = list_data_resp.meta || {};

        if (this.state.loading) {
            return <center><Spin /></center>
        }
        const { filter_query ,filter_schema} = this.state;

        return (
            <ErrorWrapper
                error={detail_cachedatasource_resp}
                onReload={() => {
                    this.detail_cachedatasource.execute()
                }}
            >
                <BasicHeader
                    title={this.state.cache_datasource_obj.name}
                    titleType="Cache Data Source"
                    subtitle="Caches"
                />

                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                            placeholder="Search For"
                            // enterButton
                            allowClear
                            autoFocus
                            value={filter_query.query}
                            style={{}}
                            onChange={(e) => {
                                e.stopPropagation();
                                e.preventDefault()
                                this.stateUpdater({
                                    stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                                        this.delay_search.onSearch(() => {
                                            this.props.history.push({
                                                search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                                            })
                                        })
                                    }
                                });
                            }}
                        />
                        {filter_schema.length>0?
                        <Button shape='circle' 
                        onClick={()=>{
                            this.setState({filter_form_visibility:true})
                        }}
                        type='primary' 
                        style={{marginLeft:16}}
                        title="Filter"
                        icon={<FilterList style={{
                            width:20
                        }}/>}
                        ></Button>
                        :null}
                    </div></div>

                    <PopUpForm
          title={"Filter Cache"}
          show_title_only
          forCreate={true}
          okText="Filter"
          initialData={this.state.filter_query}
          fields={filter_schema}
          open={this.state.filter_form_visibility}
          networkState={{}}
          onClose={() => this.setState({ filter_form_visibility: false })}
          onSubmit={(data) => {
                this.stateUpdater({
                    stateKey:'filter_query',
                    appendObj:data,
                    callback:()=>{
                        this.setState({filter_form_visibility:false})
                        this.props.history.push({
                            search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                        })
                    }
                })
            // this.handlePostPatch(data);
          }} />

                <ErrorWrapper
                    error={list_data_resp}
                    onReload={() => {
                        this.list_data.execute()
                    }}
                >
                    <div className='default-card' style={{
                        padding: 0
                    }}>
                        <Table
                            className='main-table'
                            size='small'
                            loading={list_data_resp.fetching||delete_data_resp.fetching}
                            dataSource={rowsData}
                            scroll={{ x: true }}
                            pagination={{
                                // simple: true,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.props.history.push({
                                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                defaultPageSize: 100,
                                pageSize: (rowsMeta && rowsMeta.requested_count),

                                total: (rowsMeta && rowsMeta.total_count > 10000 ? 10000 : rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${rowsMeta.total_count > 10000 ? `10,000+` : formatMoney(rowsMeta.total_count,0)} items`
                            }}
                            bordered={false}
                            columns={[
                                {
                                    dataIndex: 'created_at',
                                    title: "Created At",
                                    key: 'created_at',
                                },
                                {
                                    dataIndex: "from",
                                    title: "From",
                                    key: 'from'
                                },
                                {
                                    dataIndex: "to",
                                    title: "To",
                                    key: 'to'
                                },
                                {
                                    title: "Meta",
                                    dataIndex: 'meta_json',
                                    key: 'meta_json',
                                    render: (meta_json = {}) => <div>
                                        <pre>
                                            {JSON.stringify(meta_json, null, 4)}
                                        </pre>
                                    </div>
                                },
                                {
                                    title:"Action",
                                    dataIndex:'id',
                                    key:'action',
                                    render:(id)=>{
                                        return <div>
                                            <Popconfirm
                                            title="Are you sure you want to delete this cache?"
                                            onConfirm={()=>{
                                                this.delete_data.config({
                                                    params:{
                                                        cache_id:this.cache_id,
                                                        data_id:id
                                                    }
                                                }).execute()
                                            }}
                                            >

                                           
                                            <Button type='link' style={{
                                                color:COLORS.danger_primary
                                            }}>
                                                Delete
                                            </Button>
                                            </Popconfirm>
                                        </div>
                                    }
                                }
                            ]}

                        />
                    </div>
                </ErrorWrapper>
            </ErrorWrapper>
        );
    }


    componentDidMount() {

        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        this.setState({
            filter_query: {
                per_page: 100,
                page: 1,
                ...new_filter_query
            }
        }, () => {
            this.detail_cachedatasource.execute()
        })
    }
    componentWillReceiveProps(nextProps) {
        var oldcache_id = this.props.match.params.id;
        var newcache_id = nextProps.match.params.id;


        if (oldcache_id !== newcache_id || (
            this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
            this.cache_id = newcache_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query: {
                    per_page: 100,
                    page: 1,
                    ...parsed
                },
            }, () => {
                if (oldcache_id !== newcache_id) {
                    this.setState({
                        loading: true
                    }, () => {
                        this.detail_cachedatasource.forId(this.cache_id).execute()
                    })
                } else {
                    this.list_data.forId(this.cache_id).config({
                        params: {
                            ...this.state.filter_query
                        }
                    }).execute()
                }
            })

        }
    }

}

export default withDomains(CachedDataDetail, "cache");
